import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation validateStripeAPIKey($secretKey: String!, $publishableKey: String!) {
    validateStripeAPIKey(secretKey: $secretKey, publishableKey: $publishableKey) {
      isValid
      details {
        secretKey
        publishableKey
      }
    }
  }
`);

export default function useValidateStripeAPIKey() {
  return useMutation(MUTATION, {});
}
